import styled from '@emotion/styled';
import {motion} from 'framer-motion';

export const Container = styled(motion.div)`
  position: absolute;
  bottom: 0.625em;
  right: 1.5em;
  max-height: calc(100% - 1.5em);
  display: flex;
  flex-direction: column;
  border: 1px solid #232427;
  background-color: #18191c;
`;

export const Header = styled.div`
  padding: 1em;
  background-color: #18191c;
  display: flex;
  align-items: center;
  gap: 0.375em;
  min-width: 22.875em;
`;

export const Title = styled.h2`
  font-size: 1.625em;
  line-height: 119%;
  color: #ffffff;
  font-weight: 600;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
`;
